export default "__VITE_ASSET__Bha3Mttr__"